import React from 'react';

import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  colors
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const CompanyLogo = ({ item, statistics }) => {

  const classes = useStyles();

  return (

    <Grid container
      spacing={2}
    >

      <Grid
        item
        md={12}
        xs={12}>



      </Grid>

      <Grid
        item
        md={12}
        xs={12}>

        <Card>
          <CardHeader title="Resumo Estatístico" />
          <Divider></Divider>
          <CardContent>
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
            >
              <TableContainer component={Box}>
                <Table className={classes.table} aria-label="spanning table">
                  <TableBody>
                    <TableRow>
                      <TableCell>Dias de Operação</TableCell>
                      <TableCell align="right">{statistics.days}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Usuários</TableCell>
                      <TableCell align="right">{statistics.users}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Pessoas</TableCell>
                      <TableCell align="right">{statistics.persons}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Equipes</TableCell>
                      <TableCell align="right">{statistics.groups}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Pontos de Instalação</TableCell>
                      <TableCell align="right">{statistics.locations}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Equipamentos</TableCell>
                      <TableCell align="right">{statistics.equipments}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Alarmes Recebidos</TableCell>
                      <TableCell align="right">{statistics.alarms}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Notificações Enviadas</TableCell>
                      <TableCell align="right">{statistics.notifications}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Chamados Atendidos</TableCell>
                      <TableCell align="right">{statistics.calls}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

  );
};

export default CompanyLogo;
